import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";

const saveNewMetersValues = (changedMeters) => async (dispatch) => {
	try {
		dispatch({ type: actions.ITEM_LOADING });
		await Promise.all(
			Object.entries(changedMeters).map(([key, changedMeter]) => {
				return client.post(
					"/Meter/meters_reading",
					{
						meterId: changedMeter.meterId,
						value: changedMeter.value,
						tariffId: changedMeter.tariffId,
					},
					{
						headers: authHeader(),
					}
				);
			})
		);
		message.success("Новые показания сохранены");
	} catch (e) {
		message.error("При сохранении новых показаний произошла ошибка");
		console.log(e);
	}
};

export default saveNewMetersValues;
